// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WatchDocsPage_watchdocs__E\\+X0f {
  color: var(--white20);
}

.WatchDocsPage_header__QgDsl {
  position: relative;
  display: flex;
  align-items: center;
  height: 80px;
}
.WatchDocsPage_header__QgDsl::before {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 1px;
  animation: WatchDocsPage_borderVisible__vgEtp 0.5s;
  background-color: var(--white20);
}
.WatchDocsPage_header__QgDsl .WatchDocsPage_buttons__mqYkg {
  display: flex;
  height: 80px;
}
.WatchDocsPage_header__QgDsl .WatchDocsPage_buttons__mqYkg .WatchDocsPage_back__1Wo7q {
  height: 100%;
}
.WatchDocsPage_header__QgDsl .WatchDocsPage_buttons__mqYkg .WatchDocsPage_back__1Wo7q a {
  height: 100%;
  display: flex;
  align-items: center;
  white-space: nowrap;
  color: var(--black);
  background-color: var(--mainColor);
  font-size: 20px;
  font-weight: 800;
  border: none;
  padding: 0 45px;
  cursor: none;
  outline: none;
  box-shadow: none;
  text-transform: uppercase;
  transition: 0.5s ease all;
}
.WatchDocsPage_header__QgDsl .WatchDocsPage_buttons__mqYkg .WatchDocsPage_back__1Wo7q a svg {
  position: relative;
  top: -2px;
  margin-right: 10px;
}
.WatchDocsPage_header__QgDsl .WatchDocsPage_buttons__mqYkg .WatchDocsPage_back__1Wo7q a:active {
  transform: scale(1.05);
  background-color: var(--white);
  box-shadow: -5px -5px 20px var(--white20);
}
.WatchDocsPage_header__QgDsl .WatchDocsPage_buttons__mqYkg .WatchDocsPage_download__1WGmm {
  height: 100%;
  color: var(--black);
  border: none;
  cursor: none;
  outline: none;
  box-shadow: none;
  transition: 0.5s ease all;
  padding: 0 20px;
  border-bottom: 1px solid var(--white20);
}
.WatchDocsPage_header__QgDsl .WatchDocsPage_buttons__mqYkg .WatchDocsPage_download__1WGmm svg {
  width: 30px;
  height: 30px;
}
.WatchDocsPage_header__QgDsl .WatchDocsPage_title__I-x-D {
  color: var(--white);
  font-weight: 400;
  margin: 0;
  padding: 8px 30px 0;
  line-height: 1.3;
  width: 100%;
  font-size: 28px;
  transition: 0.5s ease all;
}

.WatchDocsPage_content__jrUQi {
  height: calc(100vh - 80px);
  overflow: hidden;
}
.WatchDocsPage_content__jrUQi .WatchDocsPage_document__seTkP {
  margin: 30px auto;
  position: relative;
  z-index: 1;
}
.WatchDocsPage_content__jrUQi .WatchDocsPage_document__seTkP .docx-wrapper {
  padding: 0;
  background: none;
}
.WatchDocsPage_content__jrUQi .WatchDocsPage_document__seTkP .docx-wrapper .docx {
  margin: 0;
  background: rgba(255, 255, 255, 0.1);
  color: var(--white);
  border: 2px dashed var(--mainColor);
}
.WatchDocsPage_content__jrUQi .WatchDocsPage_document__seTkP .docx-wrapper table {
  background: transparent !important;
}
.WatchDocsPage_content__jrUQi .WatchDocsPage_document__seTkP .docx-wrapper table td {
  background: transparent !important;
}
.WatchDocsPage_content__jrUQi .WatchDocsPage_document__seTkP .docx-wrapper p, .WatchDocsPage_content__jrUQi .WatchDocsPage_document__seTkP .docx-wrapper span {
  background: transparent !important;
  color: #fff !important;
  border: none !important;
}
.WatchDocsPage_content__jrUQi .WatchDocsPage_document__seTkP .docx-wrapper a span {
  color: var(--mainColor) !important;
}
.WatchDocsPage_content__jrUQi::before {
  opacity: 0.14;
  content: "";
  transition: 0.3s ease all;
  position: absolute;
  left: 25%;
  top: 50%;
  width: 80%;
  height: 315px;
  background: linear-gradient(90deg, #6C00F5, #CDF305);
  pointer-events: none;
  filter: blur(120px);
}

@media (max-width: 1350px) {
  .WatchDocsPage_title__I-x-D {
    font-size: 21px;
  }
}
@media (max-width: 1279px) {
  .WatchDocsPage_content__jrUQi {
    overflow-y: auto;
  }
  .WatchDocsPage_content__jrUQi::-webkit-scrollbar {
    width: 0;
  }
}
@media (max-width: 900px) {
  .WatchDocsPage_header__QgDsl {
    height: auto;
    flex-direction: column;
    align-items: stretch;
  }
  .WatchDocsPage_header__QgDsl .WatchDocsPage_buttons__mqYkg {
    justify-content: space-between;
    height: auto;
  }
  .WatchDocsPage_header__QgDsl .WatchDocsPage_buttons__mqYkg .WatchDocsPage_back__1Wo7q {
    width: 100%;
  }
  .WatchDocsPage_header__QgDsl .WatchDocsPage_buttons__mqYkg .WatchDocsPage_back__1Wo7q a {
    padding: 12px 0 13px;
    justify-content: center;
  }
  .WatchDocsPage_header__QgDsl .WatchDocsPage_buttons__mqYkg .WatchDocsPage_download__1WGmm {
    padding: 9px 10px;
  }
  .WatchDocsPage_header__QgDsl .WatchDocsPage_title__I-x-D {
    text-align: center;
    padding: 15px 8px;
    font-size: 16px;
  }
  .WatchDocsPage_document__seTkP .docx {
    max-width: 100vw;
    padding: 10px 25px 10px 25px !important;
  }
  .WatchDocsPage_document__seTkP .docx article > p:first-child {
    line-height: 2 !important;
    text-align: center !important;
  }
  .WatchDocsPage_document__seTkP .docx article > p:first-child span {
    font-size: 24px !important;
  }
}
@media (hover: hover) {
  .WatchDocsPage_button__wyrHO:hover {
    background-color: var(--white);
  }
}
@media (max-width: 767px) {
  .WatchDocsPage_content__jrUQi .WatchDocsPage_document__seTkP {
    margin: 0;
  }
}
@keyframes WatchDocsPage_borderVisible__vgEtp {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/WatchDocsPage/WatchDocsPage.module.scss","webpack://./src/shared/styles/_mixins.scss"],"names":[],"mappings":"AAKA;EACE,qBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAVa;AAMf;AAME;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,kDAAA;EACA,gCAAA;AAJJ;AAOE;EACE,aAAA;EACA,YAzBW;AAoBf;AAOI;EACE,YAAA;AALN;AAOM;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;AALR;AAOQ;EACE,kBAAA;EACA,SAAA;EACA,kBAAA;AALV;AAQQ;EACE,sBAAA;EACA,8BAAA;EACA,yCAAA;AANV;AAWI;EACE,YAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,uCAAA;AATN;AAWM;EACE,WAAA;EACA,YAAA;AATR;AAcE;EACE,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;AAZJ;;AAgBA;EACE,0BAAA;EACA,gBAAA;AAbF;AAeE;EACE,iBAAA;EACA,kBAAA;EACA,UAAA;AAbJ;AAeI;EACE,UAAA;EACA,gBAAA;AAbN;AAeM;EACE,SAAA;EACA,oCAAA;EACA,mBAAA;EACA,mCAAA;AAbR;AAgBM;EACE,kCAAA;AAdR;AAgBQ;EACE,kCAAA;AAdV;AAkBM;EACE,kCAAA;EACA,sBAAA;EACA,uBAAA;AAhBR;AAmBM;EACE,kCAAA;AAjBR;AAsBE;EACE,aAAA;ECtIF,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,oDAAA;EACA,oBAAA;EACA,mBAAA;ADmHF;;AAeA;EACE;IACE,eAAA;EAZF;AACF;AAeA;EACE;IACE,gBAAA;EAbF;EAeE;IACE,QAAA;EAbJ;AACF;AAiBA;EACE;IACE,YAAA;IACA,sBAAA;IACA,oBAAA;EAfF;EAiBE;IACE,8BAAA;IACA,YAAA;EAfJ;EAiBI;IACE,WAAA;EAfN;EAiBM;IACE,oBAAA;IACA,uBAAA;EAfR;EAmBI;IACE,iBAAA;EAjBN;EAqBE;IACE,kBAAA;IACA,iBAAA;IACA,eAAA;EAnBJ;EAuBA;IACE,gBAAA;IACA,uCAAA;EArBF;EAuBE;IACE,yBAAA;IACA,6BAAA;EArBJ;EAuBI;IACE,0BAAA;EArBN;AACF;AA0BA;EAEI;IACE,8BAAA;EAzBJ;AACF;AA6BA;EAEI;IACE,SAAA;EA5BJ;AACF;AAgCA;EACE;IACE,QAAA;EA9BF;EAiCA;IACE,WAAA;EA/BF;AACF","sourcesContent":["@import 'shared/styles/mixins';\n@import 'shared/styles/mixins';\n\n$headerHeight: 80px;\n\n.watchdocs {\n  color: var(--white20);\n}\n\n.header {\n  position: relative;\n  display: flex;\n  align-items: center;\n  height: $headerHeight;\n\n  &::before {\n    content: '';\n    position: absolute;\n    bottom: -1px;\n    left: 0;\n    width: 100%;\n    height: 1px;\n    animation: borderVisible 0.5s;\n    background-color: var(--white20);\n  }\n\n  .buttons {\n    display: flex;\n    height: $headerHeight;\n\n    .back {\n      height: 100%;\n\n      a {\n        height: 100%;\n        display: flex;\n        align-items: center;\n        white-space: nowrap;\n        color: var(--black);\n        background-color: var(--mainColor);\n        font-size: 20px;\n        font-weight: 800;\n        border: none;\n        padding: 0 45px;\n        cursor: none;\n        outline: none;\n        box-shadow: none;\n        text-transform: uppercase;\n        transition: .5s ease all;\n\n        svg {\n          position: relative;\n          top: -2px;\n          margin-right: 10px;\n        }\n\n        &:active {\n          transform: scale(1.05);\n          background-color: var(--white);\n          box-shadow: -5px -5px 20px var(--white20);\n        }\n      }\n    }\n\n    .download {\n      height: 100%;\n      color: var(--black);\n      border: none;\n      cursor: none;\n      outline: none;\n      box-shadow: none;\n      transition: .5s ease all;\n      padding: 0 20px;\n      border-bottom: 1px solid var(--white20);\n\n      svg {\n        width: 30px;\n        height: 30px;\n      }\n    }\n  }\n\n  .title {\n    color: var(--white);\n    font-weight: 400;\n    margin: 0;\n    padding: 8px 30px 0;\n    line-height: 1.3;\n    width: 100%;\n    font-size: 28px;\n    transition: .5s ease all;\n  }\n}\n\n.content {\n  height: calc(100vh - $headerHeight);\n  overflow: hidden;\n\n  .document {\n    margin: 30px auto;\n    position: relative;\n    z-index: 1;\n\n    :global .docx-wrapper {\n      padding: 0;\n      background: none;\n\n      .docx {\n        margin: 0;\n        background: rgba(#fff, .1);\n        color: var(--white);\n        border: 2px dashed var(--mainColor);\n      }\n\n      table {\n        background: transparent !important;\n\n        td {\n          background: transparent !important;\n        }\n      }\n\n      p, span {\n        background: transparent !important;\n        color: #fff !important;\n        border: none !important;\n      }\n\n      a span {\n        color: var(--mainColor) !important;\n      }\n    }\n  }\n\n  &::before {\n    opacity: .14;\n    @include backgroundGradient\n  }\n}\n\n@media(max-width: 1350px) {\n  .title {\n    font-size: 21px;\n  }\n}\n\n@media(max-width: 1279px) {\n  .content {\n    overflow-y: auto;\n\n    &::-webkit-scrollbar {\n      width: 0;\n    }\n  }\n}\n\n@media(max-width: 900px) {\n  .header {\n    height: auto;\n    flex-direction: column;\n    align-items: stretch;\n\n    .buttons {\n      justify-content: space-between;\n      height: auto;\n\n      .back {\n        width: 100%;\n\n        a {\n          padding: 12px 0 13px;\n          justify-content: center;\n        }\n      }\n\n      .download {\n        padding: 9px 10px;\n      }\n    }\n\n    .title {\n      text-align: center;\n      padding: 15px 8px;\n      font-size: 16px;\n    }\n  }\n\n  .document :global .docx {\n    max-width: 100vw;\n    padding: 10px 25px 10px 25px !important;\n\n    article > p:first-child {\n      line-height: 2 !important;\n      text-align: center !important;\n\n      span {\n        font-size: 24px !important;\n      }\n    }\n  }\n}\n\n@media(hover: hover) {\n  .button {\n    &:hover {\n      background-color: var(--white);\n    }\n  }\n}\n\n@media(max-width: 767px) {\n  .content {\n    .document {\n      margin: 0;\n    }\n  }\n}\n\n@keyframes borderVisible {\n  from {\n    width: 0;\n  }\n\n  to {\n    width: 100%;\n  }\n}\n","@mixin backgroundGradient() {\n  content: '';\n  transition: .3s ease all;\n  position: absolute;\n  left: 25%;\n  top: 50%;\n  width: 80%;\n  height: 315px;\n  background: linear-gradient(90deg, #6C00F5, #CDF305);\n  pointer-events: none;\n  filter: blur(120px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"watchdocs": `WatchDocsPage_watchdocs__E+X0f`,
	"header": `WatchDocsPage_header__QgDsl`,
	"borderVisible": `WatchDocsPage_borderVisible__vgEtp`,
	"buttons": `WatchDocsPage_buttons__mqYkg`,
	"back": `WatchDocsPage_back__1Wo7q`,
	"download": `WatchDocsPage_download__1WGmm`,
	"title": `WatchDocsPage_title__I-x-D`,
	"content": `WatchDocsPage_content__jrUQi`,
	"document": `WatchDocsPage_document__seTkP`,
	"button": `WatchDocsPage_button__wyrHO`
};
export default ___CSS_LOADER_EXPORT___;
